<template>
  <div>
    <div v-if="loadPoint" class="md-layout md-alignment-center-center md-loading">
      <div class="md-layout-item md-layout md-alignment-center-center">
        <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
      </div>
    </div>
    <div v-else>
      <div class="md-layout">
        <div class="md-layout-item">
          <md-field :class="getValidationClass('parcel_number')">
            <label>地番を入力してください</label>
            <md-input v-model="form.parcel_number" autocomplete="off"></md-input>
            <span class="md-error"
                  v-if="getValidationResponseMessage('parcel_number')">{{ getValidationResponseMessage('parcel_number') }}</span>
            <span class="md-error"
                  v-else-if="!$v.form.parcel_number.required">{{ errors.parcel_number.required }}</span>
            <span class="md-error"
                  v-else-if="!$v.form.parcel_number.chiban">{{ errors.parcel_number.chiban }}</span>
          </md-field>
        </div>
      </div>
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="md-layout md-alignment-center-right">
            <md-button class="md-primary md-raised" @click="submitParcelNumber()">
              <label>次へ進む</label>
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $                     from 'jquery';
  import 'jquery-ui';
  import 'jquery-ui/themes/base/all.css';
  import 'jquery-ui/ui/widgets/dialog';
  import 'jquery-ui/ui/widgets/resizable';
  import {validationMixin}     from "vuelidate";
  import {required}            from "vuelidate/lib/validators"
  import CommonMixin           from "../../../mixins/commonMixin";
  import LoadingSpinnerOverlay from "../../LoadingSpinnerOverlay";
  import Validation            from "../../../modules/validation";
  import Common                from "../../../modules/common";
  import Draggabilly           from "draggabilly";

  const WIDTH  = '400';
  const HEIGHT = '200';
  export default {
    name      : 'ParcelConfirmDialog',
    props     : {
      loadPoint        : {
        type   : Boolean,
        default: false,
      },
      showConfirmDialog: {
        type   : Boolean,
        default: false,
      },
      mapInit          : {
        type   : Object,
        default: null,
      },
    },
    mixins    : [validationMixin, CommonMixin],
    components: {LoadingSpinnerOverlay},
    data      : () => ({
      form  : {
        parcel_number: null,
      },
      errors: {
        parcel_number: {
          required: Validation.errorMessage(Validation.rules.required, 'parcelNumber'),
          chiban  : Validation.errorMessage(Validation.rules.chiban, 'parcelNumber'),
        },
      },
    }),
    validations() {
      return {
        form: {
          parcel_number: {
            required,
            chiban: Validation.chiban,
          },
        }
      };
    },
    mounted() {
      const self = this;
      $(this.$el).dialog({
        classes  : {
          'ui-dialog': 'ui-dialog-parcel',
        },
        draggable: false,
        resizable: false,
        height   : HEIGHT,
        width    : WIDTH,
        appendTo : '#app-content',
        close    : function () {
          self.close();
        },
      });
      this.changePosition();
      new Draggabilly('.ui-dialog-parcel', {
        handle     : '.ui-dialog-title',
        containment: '#app-content',
      });
      if ($('.ui-dialog').length === 1) {
        document.addEventListener('touchmove', this.touchMoveEventHandler, {passive: false});
      }
      if (this.mapInit && this.mapInit.dataPoints) {
        $(this.$el).dialog('option', 'title', this.getTitle());
        this.form.parcel_number = this.mapInit.dataPoints.parcel_number;
      }
    },
    watch     : {
      showConfirmDialog: function () {
        if (this.showConfirmDialog) {
          this.changePosition();
          $(this.$el).dialog('open');
        } else {
          this.close();
        }
      },
      mapInit          : function () {
        if (this.mapInit && this.mapInit.dataPoints) {
          $(this.$el).dialog('option', 'title', this.getTitle());
          this.form.parcel_number = this.mapInit.dataPoints.parcel_number;
        } else {
          this.close();
        }
      },
    },
    methods   : {
      close() {
        $(this.$el).dialog('close');
        this.$emit('closed');
        $('.ui-dialog-parcel').remove();
        if ($('.ui-dialog').length === 0) {
          document.removeEventListener('touchmove', this.touchMoveEventHandler, {passive: false});
        }
      },
      changePosition() {
        $(this.$el).dialog('option', 'position', {my: 'center', at: 'center', of: '#app-content'});
      },
      getTitle() {
        return [
          '所在：',
          this.mapInit.dataPoints.address.pref,
          this.mapInit.dataPoints.address.city,
          this.mapInit.dataPoints.address.large_section,
          this.mapInit.dataPoints.address.small_section,
        ].join('');
      },
      submitParcelNumber() {
        this.$v.form.$touch();
        if (this.$v.form.$invalid) {
          return;
        }
        $(this.$el).dialog('close');
        // 全角数字が存在する場合、半角に変換する
        this.form.parcel_number = Common.normalizeNumberAndHyphen(this.form.parcel_number);
        this.$emit('parcelConfirmed', this.form.parcel_number);
      },
      touchMoveEventHandler(event) {
        event.preventDefault();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
